import React, { useEffect, useState } from 'react'
import Button from 'components/controls/button'
import { addTopicNameTranslationsLabel } from 'shared/helpers/functional'
import history from 'routes/history'
import { Spinner } from '@blueprintjs/core'


const TopicName = props => {
    const [label, setLabel] = useState('')
    const formatTranslations = () => {
        let label = ''
        const array = props.currentProject.topicNameDetails ? [...props.currentProject.topicNameDetails.keys()] : []
        const getLastKeyInArray = array.slice(-1).pop()
        props.currentProject.topicNameDetails.forEach((value, key) => {
            label = label + addTopicNameTranslationsLabel(props.currentProject.languageAndLocalizationMap, props.currentProject.defaultLocalizationMap, key) + `${key === getLastKeyInArray ? " " : ", "}`
        }
        )
        setLabel(label)
    }

    useEffect(() => {
        formatTranslations()
    }, [props.currentProject.topicNameDetails])
    function handleClick() {
        history.push(`/projects/${props.currentProject.id}/dashboard/topic-name/translations`)
    }

    return (
        <div className="topic-name" key={props.currentProject.surveyId}>
            <div className="topic-name-content">
                <div className="topic-name-logo-container">
                    <div className="im-bubble-lines" />
                </div>
                <div className="topic-name-info">
                    <div className="topic-name-name">
                        {props.t('topic.name.title')}
                    </div>
                    <div className="topic-name-content-container">
                        <div>
                            <b className='topic-name-title'>  {props.t('topic.name.title')}: </b>
                            <p> {props.currentProject.topicNameDefault} </p>
                            {props.currentProject.topicNameDetails
                                ? <div>
                                    <p className='meeting-information-title'> {props.t('available.languages')} </p> <p> {
                                        label.length > 0 ? label : 'English (en)'
                                    }</p>
                                </div> :
                                <Spinner intent="primary" />
                            }
                        </div>
                        <div className="topic-name-footer">
                            <div className="recruiter-controls">
                                <Button
                                    className="edit-link btn-primary"
                                    onClick={handleClick}
                                > {props.t('edit.topic.name.sub.header')}</Button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default TopicName
